import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';

const { Option } = Select;

const CArticuloIndumentariaEmpresa = () => {
  const [auxiliares, setAuxiliares] = useState({
    talles: [],
    colores: [],
    generos: [],
    temporadas: []
  });

  useEffect(() => {
    const fetchAuxiliares = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/indumentaria/auxiliares`);
        const data = await res.json();
        setAuxiliares(data);
      } catch (error) {
        console.error('Error al obtener datos auxiliares:', error);
      }
    };

    fetchAuxiliares();
  }, []);

  return (
    <>
      <Form.Item name="talle" label="Talle">
        <Select placeholder="Seleccione un talle">
          {auxiliares.talles.map(t => (
            <Option key={t.tal_id} value={t.tal_nombre}>{t.tal_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="color" label="Color">
        <Select placeholder="Seleccione un color">
          {auxiliares.colores.map(c => (
            <Option key={c.col_id} value={c.col_nombre}>{c.col_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="genero" label="Género">
        <Select placeholder="Seleccione un género">
          {auxiliares.generos.map(g => (
            <Option key={g.gen_id} value={g.gen_nombre}>{g.gen_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="temporada" label="Temporada">
        <Select placeholder="Seleccione una temporada">
          {auxiliares.temporadas.map(t => (
            <Option key={t.tem_id} value={t.tem_nombre}>{t.tem_nombre}</Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default CArticuloIndumentariaEmpresa;